import Head from 'next/head';

export default function Tos({ pageData }: { pageData: any }): JSX.Element {
    return (
        <>
            <Head>
                <title>{pageData.title}</title>
                <meta name="description" content={pageData.metaDescription} />
                <meta property="og:site_name" content={pageData.title} />
                <meta
                    property="og:description"
                    name="description"
                    content={pageData.metaDescription}
                    key="description"
                />
                <meta property="og:title" name="title" content={pageData.title} />
            </Head>
            <div id="tabTOS" className="inftab-content" style={{ display: 'block' }}>
                <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
            </div>
        </>
    );
}
